import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CompartmentRuleItemFacade } from './compartment-rule-item.facade';
import { checkStoreState, setInitialStoreState } from '../../../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class CompartmentRuleItemGuard {
  constructor(private compartmentRuleItemFacade: CompartmentRuleItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { ruleId },
    } = route;
    return checkStoreState(this.compartmentRuleItemFacade, ruleId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentRuleItemFacade);
  }
}
